import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import _ from 'lodash';

import FieldSelectWithOther from './FieldSelectWithOther.jsx';
import FieldTextBox from './FieldTextBox.jsx';
import FieldDate from './FieldDate.jsx';
import { fetchDrivers } from '../../actions/driver';
import { fetchSeries } from '../../actions/series';
import { fetchTracks } from '../../actions/track';

export class BasicInfoRating extends React.Component {
  componentDidMount() {
    this.props.fetchDrivers();
    this.props.fetchSeries();
    this.props.fetchTracks();
  }

  render() {
    const { drivers, series, tracks } = this.props;

    return (
      <div>
        <Row>
          <Col xs={12} sm={6}>
            <FieldTextBox placeholder="Submitter Name *" field="submitterName" />
          </Col>
          <Col xs={12} sm={6}>
            <FieldTextBox placeholder="Submitter Team" field="submitterTeam" />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={drivers}
              defaultEmptyOption="Driver Name *"
              field="driverName"
            />
          </Col>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={series}
              defaultEmptyOption="Series *"
              field="series"
            />
          </Col>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={tracks}
              defaultEmptyOption="Track *"
              field="track"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={4}>
            <FieldDate />
          </Col>
          <Col xs={12} sm={4}>
            <FieldTextBox placeholder="Start Position" field="startPos" />
          </Col>
          <Col xs={12} sm={4}>
            <FieldTextBox placeholder="Finish Position" field="finishPos" />
          </Col>
        </Row>
      </div>
    );
  }
}

export const mapStateToProps = state => ({
  drivers: _.get(state, 'driver.result', []),
  series: _.get(state, 'series.result', []),
  tracks: _.get(state, 'track.result', []),
});

export default connect(
  mapStateToProps,
  { fetchDrivers, fetchSeries, fetchTracks },
)(BasicInfoRating);
